import styled from 'styled-components';
import { CloudImage } from '@components/CloudImage';
import { Columns } from '@components/Columns';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';

export const TextWrapper = styled(Columns.Column)<{ $isHorizontal?: boolean }>`
  width: ${({ $isHorizontal }) => ($isHorizontal ? '50%' : '100%')};
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    margin-top: ${themeSpace(9)};
    div {
      justify-content: center;
      align-items: center;
      p {
        text-align: center;
      }
    }
  }
`;

export const CloudAsset = styled(CloudImage)<{ $isHorizontal?: boolean }>`
  width: 85%;
  z-index: 2;
  position: relative;
  margin-bottom: ${({ $isHorizontal }) => ($isHorizontal ? themeSpace(0) : themeSpace(7))};
  ${themeMediaQuery('below_sm')} {
    margin-bottom: ${themeSpace(7)};
    width: 100%;
    max-width: 100%;
  }
`;

export const CloudAssetBurst = styled.svg`
  position: absolute;
  left: 52%;
  top: 47%;
  z-index: 1;
  path {
    stroke: #bc8129;
    stroke-dasharray: 102;
    stroke-dashoffset: -102;
    animation: dash 3s linear forwards;
  }
  @keyframes dash {
    to {
      stroke-dashoffset: 0;
    }
  }

  ${themeMediaQuery('below_sm')} {
    display: none;
  }
  ${themeMediaQuery('sm')} {
    left: 38%;
    top: 15%;
  }
  ${themeMediaQuery('md')} {
    left: 51%;
    top: 41%;
  }
  ${themeMediaQuery('lg')} {
    left: 52%;
    top: 47%;
  }
`;

export const CloudWrapper = styled(Columns.Column)`
  text-align: left;
  position: relative;
  z-index: 2;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const CloudAssetContainer = styled.div``;

export const MainTextPairing = styled(TextPairing)`
  .text-pairing-title {
    width: 325px;
    ${themeMediaQuery('below_sm')} {
      width: 290px;
    }
  }
  .text-pairing-body {
    width: 354px;
    ${themeMediaQuery('below_sm')} {
      width: 295px;
    }
  }
`;
